export default __webpack_public_path__ + "static/custom-0d6a218cb4300021af1610a6b7530af9.png";